import styled from 'styled-components';

type TextIconNav = {
    isTitle?: boolean;
};

export const WrapHeaderSmall = styled.div`
    position: fixed;
    inset: 0;
    background: var(--neutral-950-opacity, rgba(9, 9, 11, 0.6));
    backdrop-filter: blur(25px);
    z-index: 2;

    display: flex;
    width: 100%;
    padding: 1rem 1.5rem;
    justify-content: space-between;
    align-items: center;
    height: 4rem;

    @media (min-width: 900px) {
        display: none;
    }

    section {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        height: 100%;
    }

    a {
        color: ${({ theme }) => theme.colors['neutral-100']};
        font-style: normal;
        font-weight: 500;
        text-decoration: none;
        font-size: 0.85rem;
        line-height: 1.35rem;
    }

    svg.menu-icon {
        width: 2rem;
        height: 2rem;
    }
`;

export const Separator = styled.div`
    height: 50%;
    width: 1px;
    background-color: ${({ theme }) => theme.colors['neutral-0']};
`;

export const LogoHeader = styled.div`
    div {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    cursor: pointer;
`;

export const TextIconNav = styled.div<TextIconNav>`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem;
    cursor: pointer;
    color: #f4f4f5;
    width: 100%;

    svg {
        color: #f4f4f5;
    }

    p {
        color: #f4f4f5;
        font-size: 1em !important;
        font-weight: 500;
        line-height: 1.5rem;
    }
`;

export const WrapValuesNav = styled.div`
    flex-direction: column;
    align-items: flex;
    gap: 1rem;

    width: 100%;
    display: flex;

    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    gap: 0rem;

    &[aria-selected='true'] {
        transform: translateX(0);
    }

    .login-area {
        display: flex;
        gap: 0.5rem;
        margin-top: 1rem;
    }

    .user-options {
        max-width: fit-content;
        padding: 0.5rem 1rem;

        svg {
            color: #f4f4f5;
        }
    }
`;

export const TextNav = styled.p`
    color: #f4f4f5;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5rem;
`;

export const WrapValuesNavShop = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;

    width: 100%;
    transition: transform 0.3s ease-in-out;
`;
